import { SEOHeader } from '@/components/Headers';
import { Author } from '@/components/LandingPage/Author';
import { Footer } from '@/components/LandingPage/Footer';
import { FreeChapters } from '@/components/LandingPage/FreeChapters';
import { Hero } from '@/components/LandingPage/Hero';
import { Introduction } from '@/components/LandingPage/Introduction';
import { NavBar } from '@/components/LandingPage/NavBar';
import { Resources } from '@/components/LandingPage/Resources';
import { Screencasts } from '@/components/LandingPage/Screencasts';
import { TableOfContents } from '@/components/LandingPage/TableOfContents';
import { Testimonial } from '@/components/LandingPage/Testimonial';
import avatarImage1 from '@/images/avatars/avatar-1.png';

export default function Home() {
  return (
    <>
      <SEOHeader />
      <Hero />
      <Introduction />
      <NavBar />
      <TableOfContents />
      <Screencasts />
      <Resources />
      <FreeChapters />

      <Footer />
    </>
  );
}

Home.layout = 'None';
